import { createStore } from '@cobuildlab/react-simple-state';

export const openMobileMenuEvent = createStore<{ open: boolean }>({
  initialValue: {
    open: false,
  },
});
